import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import ProductCard from "../components/ProductCard";

export default function FavoritesPage() {
  const { user, loading } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!user) { if (!loading) setItems([]); return; }
    api.get("/favorites").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [user, loading]);

  return (
    <div data-testid="favorites-page" className="max-w-7xl mx-auto px-4 py-10">
      <h1 className="font-serif text-3xl sm:text-4xl text-forest">Favorilerim</h1>
      {items === null ? <p className="text-stone-500 mt-8">Yükleniyor...</p> : items.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border border-stone-200/80 mt-8">
          <p className="font-serif text-xl text-stone-700">{user ? "Favori ürününüz yok" : "Favorilerinizi görmek için giriş yapın"}</p>
          <Link to={user ? "/urunler" : "/giris"} className="inline-block mt-6 bg-forest hover:bg-forest-dark text-white font-semibold px-7 py-3 rounded-xl transition-colors">{user ? "Ürünleri Keşfet" : "Giriş Yap"}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mt-8">{items.map((p) => <ProductCard key={p.product_id} product={p} />)}</div>
      )}
    </div>
  );
}
